export const GET_USERS = 'GET_USERS';

export const GET_ADMIN_PROJECT_AND_TASKS_FOR_CONFIG = 'GET_ADMIN_PROJECT_AND_TASKS_FOR_CONFIG';

export const GET_USERS_WITH_CALENDARS = 'GET_USERS_WITH_CALENDARS';

export const GET_CALENDARS = 'GET_CALENDARS';

export const GET_APP_VERSION = 'GET_APP_VERSION';

export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG2 = 'GET_CONFIG2';

export const GET_HELP_SUPPORT = 'GET_HELP_SUPPORT';
export const GET_HELP_VIDEOS = 'GET_HELP_VIDEOS';
export const GET_HELP_FAQ = 'GET_HELP_FAQ';

export const GET_ALL_PERIODS_AS_ADMIN_PERIODS = 'GET_ALL_PERIODS_AS_ADMIN_PERIODS';
export const ALL_PERIODS = 'ALL_PERIODS';

export const CURRENT_PERIOD = 'CURRENT_PERIOD';

export const GET_USERS_WITH_APPROVERS = 'GET_USERS_WITH_APPROVERS';

export const ENVIRONMENT = 'ENVIRONMENT';

export const GET_AD_GROUPS = 'GET_AD_GROUPS';

export const RELEASE_NOTES = 'RELEASE_NOTES';

export const INTEGRATIONS_SETTINGS = 'INTEGRATIONS_SETTINGS';
export const INTEGRATIONS_MICROSOFT_ENTRAID_GROUPS = 'INTEGRATIONS_MICROSOFT_ENTRAID_GROUPS';
export const DATAVERSE_RESOURCE_COLUMNS = 'DATAVERSE_RESOURCE_COLUMNS';

export const INTEGRATION_DATAVERSE_ENV_LIST = 'INTEGRATION_DATAVERSE_ENV_LIST';
export const DATAVERSE_ENVIRONMENTS_TABLES = 'DATAVERSE_ENVIRONMENTS_TABLES';
export const DATAVERSE_PROJECT_COLUMNS = 'DATAVERSE_PROJECT_COLUMNS';
export const PROJECT_TEAM_COLUMNS = 'PROJECT_TEAM_COLUMNS';
export const DATAVERSE_ASSIGNMENT_COLUMNS = 'DATAVERSE_ASSIGNMENT_COLUMNS';
export const DATAVERSE_ASSIGNMENTRESOURCE_COLUMNS = 'DATAVERSE_ASSIGNMENTRESOURCE_COLUMNS';
export const DATAVERSE_PROJECTTEAMRESOURCE_COLUMNS = 'DATAVERSE_PROJECTTEAMRESOURCE_COLUMNS';
export const DATAVERSE_CALENDAR_COLUMNS = 'DATAVERSE_CALENDAR_COLUMNS';
export const SEARCH_USERS = 'SEARCH_USERS';
export const SET_USER_NUMBER = 'SET_USER_NUMBER';
export const PROJECT_APPROVALS = 'PROJECT_APPROVALS';
export const TIME_ENTRY_CORRECTIONS = 'TIME_ENTRY_CORRECTIONS';
export const IMPORT_TIME_ENTRIES = 'IMPORT_TIME_ENTRIES';
export const CONFIGURATION_FULL = 'CONFIGURATION_FULL';
export const CONFIGURATION_BASIC = 'CONFIGURATION_BASIC';
export const CONFIGS_ADMIN = 'CONFIGS_ADMIN';

export const HELP_GUIDE = 'HELP_GUIDE';

export const PERIODS_BY_DATE = 'PERIODS_BY_DATE';

export const USERS_BY_APPROVER = 'USERS_BY_APPROVER';

export const DATAVERSE_URL = 'DATAVERSE_URL';

export const DATAVERSE_IS_SETUP = 'DATAVERSE_IS_SETUP';

export const CONFIG_BY_KEY = 'CONFIG_BY_KEY';

export const HOLIDAYS_BY_COUNTRY = 'HOLIDAYS_BY_COUNTRY';

export const APPROVER_CUSTOM_FILTER = 'APPROVER_CUSTOM_FILTER';

export const POWERHUB_SERVICE_PRINCIPAL = 'POWERHUB_SERVICE_PRINCIPAL';

export const PROJECT_SOURCES = 'PROJECT_SOURCES';

export const APPROVER_BY_MANAGER = 'APPROVER_BY_MANAGER';

export const USER_CHARTS = 'USER_CHARTS';

export const PM_PROJECT_CHARTS = 'PM_PROJECT_CHARTS';

export const CHARTS = 'CHARTS';

export const LIST_ENTITIES = 'LIST_ENTITIES';

export const ENTITY_METADATA = 'ENTITY_METADATA';

export const INIT_DATA = 'INIT_DATA';

export const DESELECT_KEY = '@--none--@';

export const DELEGATES_FOR_USER = 'DELEGATES_FOR_USER';

export const MISSING_APPROVAL_PERIODS = 'MISSING_APPROVAL_PERIODS';
